import React from "react";

export default React.createContext({
    bread: false,
    setBread: (value)=>{}
})
